import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Blogs from "./components/Blogs";
import AdminPanel from "./pages/AdminPanel";
import reportWebVitals from "./reportWebVitals";

const currentPath = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById("root"));

let ComponentToRender;

if (currentPath === "/blogs") {
  ComponentToRender = <Blogs />;
} else if (currentPath === "/admin") {
  ComponentToRender = <AdminPanel />;
} else {
  ComponentToRender = <App />;
}

root.render(
  <React.StrictMode>{ComponentToRender}</React.StrictMode>
);

reportWebVitals();
